export const ContributorType = {
  Any: 'any',
  Contributor: 'contributor',
  Owner: 'owner',
  Viewer: 'viewer',
} as const;

export type ContributorType =
  (typeof ContributorType)[keyof typeof ContributorType];

/** String-literal form used by database and generated transport models. */
export type ContributorTypeValue = `${ContributorType}`;

/**
 * `Any` is absent deliberately — it is a `role_access` wildcard, not a grant
 * somebody holds.
 */
export const WORK_CAPABLE_CONTRIBUTOR_TYPES: ContributorType[] = [
  ContributorType.Owner,
  ContributorType.Contributor,
];
